import { ContactData, InscriptionCandidate, InscriptionData } from '@/Domain/Entities';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MdSelect, SdCard, MdCheckbox, MdInput } from '@/Components';
import draggable from 'vuedraggable';
import { IInscriptionCandidateReference } from '@/Domain/interfaces/Process/IProcessReference';
import ReferencesHandler from '@/Services/ReferencesHandler';
import SearchService from '@/Services/SearchService';
import { InscriptionTurn } from '@/Domain/enum';
import i18n from '../../../../lang';
import { mapState } from 'vuex';

@Component({
    name: 'references-section',
    components: { draggable, MdSelect, SdCard, MdCheckbox, MdInput },
    computed: {
        ...mapState('languagesStore', { currentLanguage: 'current' })
    }
})
export default class ReferencesSection extends Vue {
    @Prop() readonly isDraftMode!: boolean;
    @Prop() readonly isAdminRole!: boolean;
    @Prop() readonly isRequiredTurnInput!: boolean;
    @Prop() readonly inscription!: InscriptionCandidate;
    @Prop() readonly inscriptionData!: InscriptionData;
    @Prop() readonly referencesOnView!: IInscriptionCandidateReference[];
    @Prop() readonly referenceHandler!: ReferencesHandler;
    @Prop() readonly tryToSubmit!: boolean;

    search = '';
    currentLanguage!: string;

    get referencesSorted() {
        return this.referencesOnView.length > 0
            ? this.referencesOnView.sort((a: any, b: any) => {
                if (a.selected && b.selected) {
                    return a.order - b.order;
                }
                return Number(b.selected) - Number(a.selected);
            })
            : [];
    }

    get referencesFiltered() {
        if (this.referencesSorted.length > 0 && !this.search) {
            return this.referencesSorted
                .filter((reference: IInscriptionCandidateReference) => reference.turn === this.inscription.contactData.inscriptionTurn);
        } else {
            const byTurn = this.referencesSorted
                .filter((reference: IInscriptionCandidateReference) => reference.turn === this.inscription.contactData.inscriptionTurn);
            return SearchService.search({ items: byTurn, keys: ['reference'], searchText: this.search });
        }
    }

    get referencesSelected() {
        return this.referencesSorted.length > 0 ? this.referencesSorted.filter((reference: IInscriptionCandidateReference) => reference.selected) : [];
    }

    get isAtLeastOneReferenceSelected() {
        return this.referencesSelected.length > 0;
    }

    get turnTypesWithReferences() {
            return this.inscriptionData && this.inscriptionData.turnTypes.length > 0 ?
                this.inscriptionData.turnTypes.map(turn => {
                    return {
                        id: turn.id,
                        name: i18n.t(InscriptionTurn.translationsWithReferences[turn.id], { references: this.inscriptionData.getReferencesByTurn(turn.id) })
                    };
                }) : [];
        }
    
    onReferenceClick(referenceToUpdate: IInscriptionCandidateReference) {
        this.referenceHandler.onSelectedReferenceChange(referenceToUpdate, this.referencesSelected);
    }

    onDraggedElementChange(draggedElement: { moved: { oldIndex: number, newIndex: number, element: IInscriptionCandidateReference } }) {
        const { moved } = draggedElement;
        const { oldIndex, newIndex, element } = moved;
        this.referenceHandler.updateOrderOnList(element, this.referencesSelected, newIndex, oldIndex);
        this.onChangeReferences();
    }

    onOrderChange(referenceWithOrderChanged: IInscriptionCandidateReference) {
        this.referenceHandler.onReferenceOrderChange(referenceWithOrderChanged, this.referencesSelected);
        this.referenceHandler.enableDragAndrop();
    }

    onReferenceMove(evt) {
        return this.referenceHandler.onMove(evt);
    }

    onReferenceDragEnd(evt) {
        return this.referenceHandler.onDragEnd(evt);
    }

    onChangeReferences() {
        this.$emit('update:referenceOnView', this.referencesOnView);
    }

    onChangeTurn(value: any) {
        this.referenceHandler.resetReferences(this.referencesOnView);
        this.$emit('onChangeTurnWithReferences');
        this.$emit('update:inscription', new InscriptionCandidate(
            {
                ...this.inscription.toServer(),
                contactData: new ContactData({
                    ...this.inscription.contactData.toServer(),
                    inscriptionTurn: value
                })
            }));
    }
}
